import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import Step from './Step';
import StepItem from './StepItem';

/**
Gli stepper oltre a dividere una sequenza in diversi passaggi, possono anche essere utilizzati per la navigazione.
Posso anche dare un feedback di un salvataggio parziale.
 */
const Stepper = ({
  children,
  className,
  etichetteAlternative,
  onClick,
  nonlinear,
  vertical, small,
}) => {
  const stepperClasses = cns(
    'stepper',
    {
      'stepper--nonlineare': nonlinear,
      'stepper--etichetteAlternative': etichetteAlternative,
    },
    className,
  );

  return (
    <div className={cns('stepper__group', { 'stepper__group--vertical': vertical, 'stepper__group--small': small }, className)}>
      <div className={stepperClasses}>
        <div className="stepper__center">
          {React.Children.map(
            React.Children.toArray(children).filter((child) => child), (x, i) => (
              <StepItem
                key={i + 1} // eslint-disable-line react/no-array-index-key
                {...x.props}
                index={i + 1}
                onClick={onClick}
                vertical={vertical}
              />
            ),
          )}
        </div>
      </div>
      <div className="stepper__container stepper_container__block">
        <div className="stepper__wrapper">
          <div className="stepper__padder">
            {React.Children.map(React.Children.toArray(children).filter((child) => child),
              (x) => (x.props.state === Step.State.ACTIVE
                ? <div>{(x.props.code || x.props.children)}</div>
                : <div />))}
          </div>
        </div>
      </div>
    </div>
  );
};

Stepper.Step = Step;
Stepper.State = Step.State;

Stepper.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Assegna al componente lo stile etichette alternative */
  etichetteAlternative: PropTypes.bool,
  /** Assegna al componente lo stile non lineare */
  nonlinear: PropTypes.bool,
  /**
   * Callback invocata al click dello step:
   * ```
   *  onClick(index)
   * ```
   * dove:
   * * *index*: indice dello step selezionato
   */
  onClick: PropTypes.func,
  /** Assegna al componente lo stile verticale */
  vertical: PropTypes.bool,
  /** Assegna al componente lo stile small (solo in visualizzazione verticale) */
  small: PropTypes.bool,
};

Stepper.defaultProps = {
  children: null,
  className: '',
  etichetteAlternative: false,
  nonlinear: false,
  onClick: null,
  vertical: false,
  small: false,
};

export default Stepper;
